import { ENV } from 'constants/env';
import dayjs from 'dayjs';

export const getDebugInfo = (email?: string, includeUrl = false) => {
  const info = [
    {
      name: 'Build',
      value: dayjs(import.meta.env.VITE_BUILD_TIMESTAMP).format('MMMM D, YYYY h:mm A'),
    },
    {
      name: 'Commit',
      value: import.meta.env.VITE_COMMIT_HASH.replace('\n', ''),
    },
    {
      name: 'Environment',
      value: ENV.VITE_ENVIRONMENT,
    },
  ];
  if (email) {
    info.push({ name: 'User', value: email });
  }
  if (includeUrl) {
    info.push({
      name: 'URL',
      value: window.location.toString(),
    });
  }
  return info;
};
